module.exports = __webpack_public_path__ + "static/web-painting-6-ac82f037fcf8242e0117d33e1c456321.jpg";